var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 16,
    viewBox: "0 0 1 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DS/Rule Lines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vertical Rule Line",
    d: "M0.5 0V16",
    stroke: "#5E5E5E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipe);
export default __webpack_public_path__ + "static/media/pipe.7cebb0a4e67408b3413391508a33bf97.svg";
export { ForwardRef as ReactComponent };